"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCheckCustomerExists = exports.useUpdateCustomer = exports.useCreateCustomer = exports.useCreateDefaultCustomer = exports.useSearchCustomer = exports.useFetchDefaultCustomer = exports.useFetchCustomer = void 0;
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
const customerAction_1 = require("./customerAction");
const useFetchCustomer = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const fetchCustomerLoading = (0, react_redux_1.useSelector)((state) => state['customer/fetch'].loading);
    const fetchCustomerError = (0, react_redux_1.useSelector)((state) => state['customer/fetch'].error);
    const fetchCustomerData = (0, react_redux_1.useSelector)((state) => state['customer/fetch'].data);
    const fetcHCustomerErrMsg = (0, react_redux_1.useSelector)((state) => state['customer/fetch'].errorMessage);
    const fetchCustomer = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
        if (!userLogged) {
            history('auth/sign-in');
            return;
        }
        yield dispatch((0, customerAction_1.fetch)(payload));
    });
    return {
        fetchCustomerLoading,
        fetchCustomerError,
        fetchCustomerData,
        fetcHCustomerErrMsg,
        fetchCustomer
    };
};
exports.useFetchCustomer = useFetchCustomer;
const useFetchDefaultCustomer = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const fetchDefaultCustomerLoading = (0, react_redux_1.useSelector)((state) => state['customer/fetchDefaultCustomer'].loading);
    const fetchDefaultCustomerError = (0, react_redux_1.useSelector)((state) => state['customer/fetchDefaultCustomer'].error);
    const fetchDefaultCustomerData = (0, react_redux_1.useSelector)((state) => state['customer/fetchDefaultCustomer'].data);
    const fetchDefaultCustomerErrMsg = (0, react_redux_1.useSelector)((state) => state['customer/fetchDefaultCustomer'].errorMessage);
    const fetchDefaultCustomerHook = () => __awaiter(void 0, void 0, void 0, function* () {
        let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
        if (!userLogged) {
            history('auth/sign-in');
            return;
        }
        yield dispatch((0, customerAction_1.fetchDefaultCustomer)());
    });
    return {
        fetchDefaultCustomerLoading,
        fetchDefaultCustomerError,
        fetchDefaultCustomerData,
        fetchDefaultCustomerErrMsg,
        fetchDefaultCustomerHook
    };
};
exports.useFetchDefaultCustomer = useFetchDefaultCustomer;
const useSearchCustomer = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const searchCustomerLoading = (0, react_redux_1.useSelector)((state) => state['customer/search'].loading);
    const searchCustomerError = (0, react_redux_1.useSelector)((state) => state['customer/search'].error);
    const searchCustomerData = (0, react_redux_1.useSelector)((state) => state['customer/search'].data);
    const searchCustomerErrMsg = (0, react_redux_1.useSelector)((state) => state['customer/search'].errorMessage);
    const searchCustomer = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
        if (!userLogged) {
            history('auth/sign-in');
            return;
        }
        yield dispatch((0, customerAction_1.search)(payload));
    });
    return {
        searchCustomerLoading,
        searchCustomerError,
        searchCustomerData,
        searchCustomerErrMsg,
        searchCustomer
    };
};
exports.useSearchCustomer = useSearchCustomer;
const useCreateDefaultCustomer = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const createDefaultCustomerLoading = (0, react_redux_1.useSelector)((state) => state['customer/createDefaultCustomer'].loading);
    const createDefaultCustomerError = (0, react_redux_1.useSelector)((state) => state['customer/createDefaultCustomer'].error);
    const createDefaultCustomerData = (0, react_redux_1.useSelector)((state) => state['customer/createDefaultCustomer'].data);
    const createDefaultCustomerErrMsg = (0, react_redux_1.useSelector)((state) => state['customer/createDefaultCustomer'].errorMessage);
    const createDefaultCustomerHook = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('auth/sign-in');
                return;
            }
            const res = yield dispatch((0, customerAction_1.createDefaultCustomer)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error('Error while creating customer');
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        createDefaultCustomerLoading,
        createDefaultCustomerError,
        createDefaultCustomerData,
        createDefaultCustomerErrMsg,
        createDefaultCustomerHook
    };
};
exports.useCreateDefaultCustomer = useCreateDefaultCustomer;
const useCreateCustomer = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const createCustomerLoading = (0, react_redux_1.useSelector)((state) => state['customer/create'].loading);
    const createCustomerError = (0, react_redux_1.useSelector)((state) => state['customer/create'].error);
    const createCustomerData = (0, react_redux_1.useSelector)((state) => state['customer/create'].data);
    const createCustomerErrMsg = (0, react_redux_1.useSelector)((state) => state['customer/create'].errorMessage);
    const createCustomer = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('auth/sign-in');
                return;
            }
            const res = yield dispatch((0, customerAction_1.create)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                console.log('Success in creation', res.payload);
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                console.log('Error in creation');
                throw new Error('Error while creating customer');
            }
        }
        catch (error) {
            console.log('Exception in creation');
            onComplete(false, true, error.message);
        }
    });
    return {
        createCustomerLoading,
        createCustomerError,
        createCustomerData,
        createCustomerErrMsg,
        createCustomer
    };
};
exports.useCreateCustomer = useCreateCustomer;
const useUpdateCustomer = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const updateCustomerLoading = (0, react_redux_1.useSelector)((state) => state['customer/update'].loading);
    const updateCustomerError = (0, react_redux_1.useSelector)((state) => state['customer/update'].error);
    const updateCustomerData = (0, react_redux_1.useSelector)((state) => state['customer/update'].data);
    const updateCustomerErrMsg = (0, react_redux_1.useSelector)((state) => state['customer/update'].errorMessage);
    const updateCustomer = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('auth/sign-in');
                return;
            }
            const res = yield dispatch((0, customerAction_1.update)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error('Error while updating customer');
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        updateCustomerLoading,
        updateCustomerError,
        updateCustomerData,
        updateCustomerErrMsg,
        updateCustomer
    };
};
exports.useUpdateCustomer = useUpdateCustomer;
const useCheckCustomerExists = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const checkCustomerExistsLoading = (0, react_redux_1.useSelector)((state) => state['customer/checkCustomerExists'].loading);
    const checkCustomerExistsError = (0, react_redux_1.useSelector)((state) => state['customer/checkCustomerExists'].error);
    const checkCustomerExistsData = (0, react_redux_1.useSelector)((state) => state['customer/checkCustomerExists'].data);
    const checkCustomerExistsErrMsg = (0, react_redux_1.useSelector)((state) => state['customer/checkCustomerExists'].errorMessage);
    const checkCustomerExist = (mobile) => __awaiter(void 0, void 0, void 0, function* () {
        let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
        if (!userLogged) {
            history('auth/sign-in');
            return;
        }
        yield dispatch((0, customerAction_1.checkCustomerExists)(mobile));
    });
    return {
        checkCustomerExistsLoading,
        checkCustomerExistsError,
        checkCustomerExistsData,
        checkCustomerExistsErrMsg,
        checkCustomerExist
    };
};
exports.useCheckCustomerExists = useCheckCustomerExists;
